import MuiDialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import classes from './Dialog.module.scss';

export default function Dialog({
  title,
  open = true,
  children,
  ...rest
}: DialogProps) {
  return (
    <MuiDialog
      aria-labelledby="dialog-title"
      maxWidth="md"
      open={open}
      {...rest}
    >
      <DialogTitle className={classes.title} id="dialog-title">
        {title}
      </DialogTitle>
      {children}
    </MuiDialog>
  );
}

export interface DialogProps extends Omit<MuiDialogProps, 'open'> {
  open?: boolean;
  title: string;
}
